export * from "./editorial-details";
